module.exports = __webpack_public_path__ + "static/media/viewImage.6af04a8e.svg";